var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.569,
    height: 34.524,
    viewBox: "0 0 28.569 34.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "my-orders-icon",
    d: "M1.313,8.073H7.3V6.853a6.862,6.862,0,1,1,13.724,0V8.073h6.033a1.313,1.313,0,0,1,.93.385,1.329,1.329,0,0,1,.385.927V29.6a4.729,4.729,0,0,1-4.715,4.715H4.715A4.729,4.729,0,0,1,0,29.6V9.386A1.316,1.316,0,0,1,1.313,8.073Zm4.377,9.759H8.318a.346.346,0,0,1,.341.344V20.8a.344.344,0,0,1-.344.344H5.689a.344.344,0,0,1-.344-.344V18.176a.346.346,0,0,1,.344-.344Zm6.7,2.7a1.062,1.062,0,0,1,0-2.092H22.727a1.062,1.062,0,0,1,0,2.092ZM5.215,27.141a.559.559,0,0,1,.109-.818.648.648,0,0,1,.874-.028l.612.628L8.34,25.356a.559.559,0,0,1,.821.087.651.651,0,0,1,.056.874L7.189,28.4a.559.559,0,0,1-.821-.087l-.047-.056a.6.6,0,0,1-.092-.075Zm7.106.782a1.063,1.063,0,0,1,.008-2.092H22.663a1.062,1.062,0,0,1,0,2.092ZM8.968,8.073H19.347V6.853a5.189,5.189,0,0,0-10.376,0V8.073ZM7.293,11.316V9.743H1.676V29.6a3.053,3.053,0,0,0,3.042,3.042H23.654A3.072,3.072,0,0,0,26.7,29.6V9.743H21.02v1.589a1.91,1.91,0,1,1-1.676-.028V9.743H8.971v1.578a1.91,1.91,0,1,1-1.676,0Z",
    transform: "translate(0.1 0.11)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.6e6c4790efc2e2f549090a45b3bea962.svg";
export { ForwardRef as ReactComponent };